<template>
  <b-row class="steps-background" no-gutters>
    <b-col cols="3" sm="3" md="3" lg="3" xl="3" class="float-left text-center align-self-center">
      <slot name="previous">
        <b-link v-if="currentStep > 1" :class="prevClass" href="javascript:void(0)" @click="prevClick">
          <slot name="prev-btn-content">
            {{ prevText }}
          </slot>
        </b-link>
      </slot>
    </b-col>
    <b-col cols="6" sm="6" md="6" lg="6" xl="6" class="text-center align-self-center text-secondary font-weight-bold d-block">
      Step {{ currentStep }} of {{ totalSteps }}
    </b-col>
    <b-col cols="3" sm="3" md="3" lg="3" xl="3" class="float-right align-self-center">
      <slot name="next">
        <b-button
          variant="primary"
          class="w-100 font-weight-bold"
          href="javascript:void(0)"
          :disabled="isButtonDisabled"
          @click="nextClick"
        >
          <slot name="next-btn-content">
            {{ nextText }}
          </slot>
        </b-button>
      </slot>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Steps',
  props: {
    prevClass: {
      type: String,
      default: 'w-100 font-weight-bold',
      required: false,
    },
    prevText: {
      type: String,
      default: '&lt; Previous',
      required: false,
    },
    totalSteps: {
      type: [String, Number],
      default: 0,
      required: false,
    },
    currentStep: {
      type: [String, Number],
      default: 0,
      required: false,
    },
    nextText: {
      type: String,
      default: 'Next',
      required: false,
    },
    isButtonDisabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    nextClick() {
      this.$emit('nextClick');
    },
    prevClick() {
      this.$emit('prevClick');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.steps-background {
  background-color: $dp-gray-1;
}
</style>
